<script setup lang="ts">
import { Download, Info, Pencil, Pin, PinOff, SquarePlus, Trash2 } from '@lucide/vue'
import { computed } from 'vue'

import type { ActionMenuItem } from '@/components/ui/actionMenu'
import ActionMenuList from '@/components/ui/ActionMenuList.vue'
import type { TourListItem } from '@/types/tour'

defineOptions({ name: 'LibraryTourActionSheetContent' })

const props = defineProps<{
  tour: TourListItem
  isDownloading?: boolean
}>()

const emit = defineEmits<{
  rename: []
  download: []
  manageCollections: []
  togglePinned: []
  viewDetails: []
  delete: []
}>()

const actionItems = computed<ActionMenuItem[]>(() => [
  { key: 'rename', label: 'Rename', icon: Pencil, onSelect: () => emit('rename') },
  {
    key: 'download',
    label: 'Download GPX',
    icon: Download,
    loading: props.isDownloading,
    onSelect: () => emit('download'),
  },
  {
    key: 'manage-collections',
    label: 'Add to collection',
    icon: SquarePlus,
    onSelect: () => emit('manageCollections'),
  },
  {
    key: 'toggle-pinned',
    label: props.tour.isPinned ? 'Remove from Pinned' : 'Pin',
    icon: props.tour.isPinned ? PinOff : Pin,
    iconClass: props.tour.isPinned ? 'text-amber-600' : 'text-gray-400',
    onSelect: () => emit('togglePinned'),
  },
  { key: 'view-details', label: 'View details', icon: Info, onSelect: () => emit('viewDetails') },
  {
    key: 'delete',
    label: 'Delete',
    icon: Trash2,
    danger: true,
    separated: true,
    onSelect: () => emit('delete'),
  },
])
</script>

<template>
  <ActionMenuList :items="actionItems" />
</template>
